import React from 'react'
import styled from 'react-emotion'
import Helmet from 'react-helmet'

import Section from '../components/section/Section'
import Button from '../components/buttons/Button'
import { SectionTwoCol, SectionColumn } from '../components/section/SectionTwoCol'
import { TwoCol, LeftCol, RightCol, } from '../components/two-col'
import SectionHeader from '../components/section/SectionHeader'
import SectionPreHeader from '../components/section/SectionPreHeader'
import SubHeader from '../components/section/SubHeader'
import CalloutContainer from '../components/CalloutContainer'
import HubspotFormSection from '../components/forms/HubspotFormSection'

import heroImg from '../assets/features/hero.jpg'
import feature1Img from '../assets/features/feature-1.png'
import feature2Img from '../assets/features/feature-2.png'
import feature3Img from '../assets/features/feature-3.png'
import feature4Img from '../assets/features/feature-4.png'
import feature5Img from '../assets/features/feature-5.png'
import seoHero from '../assets/features/seo-hero.png'


class FeaturesPage extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div>
        <Helmet
          title={'Powerful Features'}
          meta={[
            { name: 'og:title', content: 'Powerful Features' },
            { name: 'description', content: 'Designed to elevate the guest experience, drive more revenue, and increase ratings.' },
            { name: 'og:description', content: 'Designed to elevate the guest experience, drive more revenue, and increase ratings.' },
            { name: 'og:image', content: seoHero },
            { name: 'og:type', content: "website" },
            { name: 'og:locale', content: "en_US" },
          ]}
        />
        <TwoCol bgColor={'#18aa7a'}>
          <LeftCol bgColor={'#18aa7a'} skew color="#fff">
            <h1>Whistle's<br/> portfolio of<br/> features</h1>
            <SubHeader>Our unique features offer more than a messaging tool—<br/> they offer a way to get ahead in the hospitality industry.</SubHeader>
            <CalloutContainer align={'left'}>
              <Button secondary to="/schedule" icon>Book A Demo</Button>
            </CalloutContainer>
          </LeftCol>
          <RightCol image bgImgSrc={heroImg} />
        </TwoCol>
        <SectionTwoCol light>
          <SectionColumn left>
            <img src={feature1Img} alt="Chatbot Automation Live Chat" />
          </SectionColumn>
          <SectionColumn>
            <SectionPreHeader align="center">Chatbot Automation</SectionPreHeader>
            <SectionHeader lower align="center">Drive more bookings</SectionHeader>
            <SubHeader align="center">With our Chatbot Response feature you'll have hundreds of automated responses answering guests questions.</SubHeader>
          </SectionColumn>
        </SectionTwoCol>
        <SectionTwoCol>
          <SectionColumn>
            <SectionPreHeader align="center">Team Messaging</SectionPreHeader>
            <SectionHeader lower align="center">Streamline operations</SectionHeader>
            <SubHeader align="center">Group and team messages to help staff stay on-task while staff training and support ensures everyones success.</SubHeader>
          </SectionColumn>
          <SectionColumn right>
            <img src={feature2Img} alt="Team Messaging" />
          </SectionColumn>
        </SectionTwoCol>
        <SectionTwoCol light>
          <SectionColumn left>
            <img src={feature3Img} alt="Unlimited Messaging" />
          </SectionColumn>
          <SectionColumn>
            <SectionPreHeader align="center">Unlimited Messaging</SectionPreHeader>
            <SectionHeader lower align="center">Answer guests at any time</SectionHeader>
            <SubHeader align="center">There's no limit to how many request you can answer with automated responses as well as personalized messages.</SubHeader>
          </SectionColumn>
        </SectionTwoCol>
        <SectionTwoCol>
          <SectionColumn>
            <SectionPreHeader align="center">Integrations + Analytics</SectionPreHeader>
            <SectionHeader lower align="center">All at your fingertips</SectionHeader>
            <SubHeader align="center">Seamlessly integrate your PMS and get real-time, in-app analytics to have tasks as well as insights all-in-one place.</SubHeader>
          </SectionColumn>
          <SectionColumn center>
            <img src={feature4Img} alt="PMS Integrations + Analytics" />
          </SectionColumn>
        </SectionTwoCol>
        <SectionTwoCol light>
          <SectionColumn center>
            <img src={feature5Img} alt="Voice Intelligence + Guest Surveys" />
          </SectionColumn>
          <SectionColumn>
            <SectionPreHeader align="center">Voice Intelligence + Guest Surveys</SectionPreHeader>
            <SectionHeader lower align="center">Communication is key</SectionHeader>
            <SubHeader align="center">With voice-controlled intelligence you can  communicate hands-free with guests. Plus our text messaging surveys gives you real-time feedback before guests depart.</SubHeader>
          </SectionColumn>
        </SectionTwoCol>
        <HubspotFormSection
          id="book-demo"
          formId="7d86c04f-e98e-42eb-ae79-ff2b14c7605a"
          trackingId={process.env.ADWORDS_TRACKER_LEAD_FORM}
        />
      </div>
    )
  }
}
 
export default FeaturesPage;


// WEBPACK FOOTER //
// ./src/pages/features.js